import React from 'react';
import { IoIosAlert } from 'react-icons/io';

import {
	BetstopLink,
	HelpLinkText,
	HelpSection,
	StyledText,
	TermItemText,
	TermLink,
	TermSection,
	TermsTitle,
} from './sharedComponents';
import { BodyContainer } from 'playup-web-core/src/pageComponents/PortalMenu/sharedStyles';
import { Button, ErrorMessage } from 'playup-web-core';

const AUContent = ({ isSmall, brandName, responsibleGamblingUrl, termsUrl, showConfirm, errorMessage }: Props) => (
	<BodyContainer isSmallScreen={isSmall}>
		<StyledText>
			Should you want to stop betting with us you may close your account.
			<br />
			Once closed, you may reactivate your account at any time by contacting our customer support team.
			<br />
			If you feel you have issues controlling your gambling, the following links and contact numbers may assist:
		</StyledText>
		<HelpSection isSmallScreen={isSmall}>
			<BetstopLink href="https://www.betstop.gov.au/" target="_blank">BETSTOP - National Self exclusion Register</BetstopLink>
			<HelpLinkText href={responsibleGamblingUrl} rel="noopener noreferrer nofollow" target="_blank">
				{brandName} Responsible Gambling Policy
			</HelpLinkText>
			<HelpLinkText href="https://gamblershelp.com.au/get-help" rel="noopener noreferrer nofollow" target="_blank">
				Gambler&apos;s Help
			</HelpLinkText>
			<HelpLinkText href="tel:+611800858858">1800 858 858</HelpLinkText>
		</HelpSection>
		<TermSection isSmallScreen={isSmall}>
			<TermsTitle>
				<IoIosAlert size={24} style={{ marginRight: 5 }} /> IMPORTANT
			</TermsTitle>
			<TermItemText>• Once activated, account closure will take place immediately.</TermItemText>
			<TermItemText>• Any pending bets will remain active.</TermItemText>
			<TermItemText>
				• If you have a balance, withdraw your funds prior to closure or contact {brandName} customer support.
			</TermItemText>
			<TermItemText>
				• Once your account is closed, you will not receive marketing emails and alerts. Please allow 48 hours for these
				alerts to cease.
			</TermItemText>
			<TermItemText>
				• By proceeding, you understand and accept {brandName}&apos;s{' '}
				<TermLink href={termsUrl} rel="noopener noreferrer nofollow" target="_blank">
					Terms
				</TermLink>
			</TermItemText>
		</TermSection>
		{errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
		<Button kind="danger" onClick={showConfirm}>
			Close Account
		</Button>
	</BodyContainer>
);

export default AUContent;

interface Props {
	isSmall: boolean;
	brandName: string;
	responsibleGamblingUrl: string;
	termsUrl: string;
	errorMessage?: string;
	showConfirm: () => void;
}
